import { Entity } from "./Entity";

export interface ITrailer {
    id: string;
    name: string;
    comment: string;
    groups: any[];
    licensePlate?: string;
    licenseState?: string;

    // MYG-148762: set when a trailer is represented by its underlying trailer Device
    tmpTrailerId?: string;

    // This property is used to identify Trailers which are attached while the app is offline
    // eslint-disable-next-line @typescript-eslint/naming-convention
    _isTemp?: boolean;
}

export class Trailer extends Entity implements INamedEntity {

    id: string;
    name: string;
    comment: string;
    groups: any[];
    licensePlate?: string;

    // This property is used to identify Trailers which are attached while the app is offline
    // eslint-disable-next-line @typescript-eslint/naming-convention
    _isTemp?: boolean;

    constructor(obj?: any) {
        super(obj);
        this.id = obj && obj.id || "";
        this.name = obj && obj.name || "";
        this.comment = obj && obj.comment || null;
        this.groups = obj && obj.groups || [];
        this.licensePlate = obj && obj.licensePlate || undefined;
        this._isTemp = obj && obj._isTemp || false;
    }

    toJSON() {
        return {
            id: this.id,
            name: this.name,
            comment: this.comment,
            groups: this.groups,
            licensePlate: this.licensePlate,
            _isTemp: this._isTemp
        };
    }
}